import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Typewriter } from "react-simple-typewriter";
import useMode from "../../../Hooks/useMode";
import img from "../../../images/edit.png";
import "./About.css";

const About = () => {
  const { theme } = useMode();
  return (
    <div
      className={`${
        theme === "light" ? "about-container-light" : "about-container-dark"
      } about-container`}
      id="about"
    >
      <div data-aos="fade-up" className="text-center mb-5">
        <p className="txt text-uppercase">Know Me More</p>
        <h3
          className={`${
            theme === "light" ? "text-dark" : "text-light"
          } text fw-bold`}
        >
          About Me
        </h3>
      </div>
      <div className="about_bg">
        <Container>
          <Row className="px-1 d-flex align-items-center">
            <Col data-aos="fade-right" xs={12} md={5}>
              <div className="">
                <img src={img} width="70%" alt="" />
              </div>
            </Col>
            <Col data-aos="fade-left" xs={12} md={7}>
              <div className="about">
                <h5>I AM AVAILABLE FOR</h5>
                <p className="icon">
                  <Typewriter
                    typeSpeed={70}
                    deleteSpeed={50}
                    delaySpeed={1000}
                    loop
                    cursor
                    cursorStyle="_"
                    cursorBlinking={true}
                    words={[
                      "Mobile App Development",
                      "Web Development",
                      "Web Design",
                    ]}
                  />
                </p>
                <h5>Projects</h5>
                <h5 className="mt-5">
                  "3" Rules of <span style={{ color: "#f9004d" }}>Me </span>
                </h5>
                <div className="learning-container">
                  <div>
                    <h6 style={{ color: "#f9004d" }}>01</h6>
                    <p>Define Clear Objectives and User Needs.</p>
                  </div>
                  <div>
                    <h6 style={{ color: "#f9004d" }}>02</h6>
                    <p>
                      Plan the User Experience (UX) and User Interface (UI).
                    </p>
                  </div>
                  <div>
                    <h6 style={{ color: "#f9004d" }}>03</h6>
                    <p>Choose the Right Technology Stack.</p>
                  </div>
                </div>
                <p>
                  I'm developer focused on crafting user‐friendly experiences; I
                  am passionate about building excellent software that improves
                  the lives of those around me. I am a big fan of learning while
                  building. I have created multiple projects, some of them are
                  my professional projects and some of them are experimental
                  just to explore & learn.
                </p>
                <a
                  href="/SAIFUL ISLAM.pdf"
                  download
                  className={`${
                    theme === "light" ? "resume-btn-light" : "resume-btn-dark"
                  } resume-btn`}
                >
                  <i className="fas fa-download icon"></i> Take Resume
                </a>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
};

export default About;
